module.exports = __webpack_public_path__ + "static/img/summer_banner.67c5ef85.jpg";